<div *ngIf="notification.operationType === 'plugin_install_requested'">
  <ui-assignee-avatar class="avatar" [uiAssignee]="notification.notificationData.actor | asAssignee" uiSize="sm"></ui-assignee-avatar>
  <div class="title">{{ "has_requested_to_install" | localize: { names: notification.notificationData.actor.names, pluginTitle: notification.notificationData.item.pluginTitle } }}</div>
  <div class="date">{{ notification.createdAt | date: "dd MMM, yyyy" }}</div>
  <div class="summary">
    <span class="item" [innerHTML]="'information_view_install' | localize: { comment: notification.notificationData.item.comment, url: notification.notificationData.item.url }"></span>
  </div>
</div>
